import { SystemRecommendationSelectionsEntry } from 'features/structure/structure-slice';
import { RecommendationSelections } from 'utils/recommendations-strip-logic';
import { TonnageRecord } from 'utils/tonnage-logic';

export type SizeRecordOverrides = {
  tonnage?: TonnageRecord;
};

// Full-record PATCH body from the mirror entry plus the size record that
// changed. The selections PATCH replaces the WHOLE persisted record (only
// lastResults is server-preserved), so every other field — the PTAC
// preferences included — is re-sent from the mirror. A null entry means
// "context fetched, nothing saved": an honest empty record carries the size.
// Optional record fields are omitted when absent so the strict ss-api
// schema — and JSON serialization — see only real values.
export function buildSizeRecordSelectionsPayload(
  entry: SystemRecommendationSelectionsEntry | null | undefined,
  overrides: SizeRecordOverrides
): RecommendationSelections {
  const payload: RecommendationSelections = {
    wantIds: entry?.wantIds ?? [],
    haveId: entry?.haveId ?? null,
    refrigerant: entry?.refrigerant ?? null,
    age: entry?.age ?? null
  };
  if (entry) {
    if (entry.useRecommendations !== undefined) {
      payload.useRecommendations = entry.useRecommendations;
    }
    if (entry.fingerprint !== undefined) {
      payload.fingerprint = entry.fingerprint;
    }
    if (entry.virtualCodes !== undefined) {
      payload.virtualCodes = entry.virtualCodes;
    }
    if (entry.virtualFuel !== undefined) {
      payload.virtualFuel = entry.virtualFuel;
    }
    if (entry.ptac) {
      payload.ptac = entry.ptac;
    }
  }
  const tonnage = overrides.tonnage ?? entry?.tonnage;
  if (tonnage) {
    payload.tonnage = tonnage;
  }
  return payload;
}

export function withMirroredSizeRecords(
  next: RecommendationSelections,
  entry: SystemRecommendationSelectionsEntry | null | undefined
): RecommendationSelections {
  const merged = { ...next };
  if (entry?.tonnage) {
    merged.tonnage = entry.tonnage;
  }
  if (entry?.ptac) {
    merged.ptac = entry.ptac;
  }
  return merged;
}
